import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import FullCalendar from 'vue-full-calendar'

import router from './router'
import store from './store'

import 'swiper/dist/css/swiper.css'
import 'fullcalendar/dist/fullcalendar.css'

var VueScrollTo = require('vue-scrollto')
Vue.use(Vuex)
Vue.use(VueResource)
Vue.use(VueAwesomeSwiper)
Vue.use(require('vue-moment'))
Vue.use(FullCalendar)
Vue.use(VueScrollTo)

if (process.env.NODE_ENV === 'development') {
  Vue.config.productionTip = false
  Vue.http.options.root = 'http://localhost:3000'
  Vue.prototype.urlFiles = 'http://localhost:3000/'
} else {
  // window.console.log = () => {}

  Vue.config.productionTip = true
  Vue.http.options.root = 'https://fibra-api.fibraexperts.com.br'
  Vue.prototype.urlFiles = 'https://fibra-api.fibraexperts.com.br/'
}

Vue.http.options.root = 'https://fibra-api.fibraexperts.com.br'
Vue.prototype.urlFiles = 'https://fibra-api.fibraexperts.com.br/'

new Vue({
  router,
  store,
  http: {
    root: '/root'
  },
  render: h => h(App)
}).$mount('#app')
